import {isNilOrEmpty} from 'ramda-adjunct';

import {
  WarrantyTermsAndConditionsRequestBody,
  WarrantyTermsAndConditionsRequestBodySchema,
} from '@dms/api/sales';

/**
 * Converts the per-locale form map (locale code -> text) into the API request array,
 * keeping only locales whose text is non-empty (after trimming). Each entry is validated
 * through the request-body schema so the `locale` key is narrowed to the API `Locale`
 * enum; any key that is not a known locale is dropped. Terms & conditions are optional,
 * so the result may be an empty array.
 */
export const buildTermsAndConditionsRequest = (
  termsAndConditions: Record<string, string>
): WarrantyTermsAndConditionsRequestBody[] =>
  Object.entries(termsAndConditions).flatMap(([locale, text]) => {
    const trimmedText = text.trim();

    if (isNilOrEmpty(trimmedText)) {
      return [];
    }

    const result = WarrantyTermsAndConditionsRequestBodySchema.safeParse({
      locale,
      text: trimmedText,
    });

    return result.success ? [result.data] : [];
  });
